import type { Wish } from "@corklog/shared";

import type { WineFormValues } from "./components/WineForm.js";

/**
 * A wish as the registration form wants it — task 10.64.
 *
 * One function for two journeys: correcting a wish opens the form on it, and
 * buying one opens the *registration* on it. Both are the same ten fields,
 * which is the point of the wish being the registration's own request.
 *
 * What is left out is what a wish never had: an id, a date, and any provenance
 * on the four years — the registration that follows stamps `Owner` on a year
 * typed into the form, which is what a year carried over from a wish is.
 */
export function wishFormValues(wish: Wish): WineFormValues {
  return {
    name: wish.name,
    type: wish.type,
    countryCode: wish.countryCode,
    producer: wish.producer,
    region: wish.region,
    style: wish.style,
    vintage: wish.vintage,
    grapes: wish.grapes,
    isNonVintage: wish.isNonVintage,
    baseVintage: wish.baseVintage,
    disgorgedOn: wish.disgorgedOn,
    dosageGramsPerLitre: wish.dosageGramsPerLitre,
    alcoholPercent: wish.alcoholPercent,
    drinkFrom: wish.drinkFrom,
    peakFrom: wish.peakFrom,
    peakTo: wish.peakTo,
    drinkBy: wish.drinkBy,
  };
}
